import React, { Component } from "react";
import { Button, Row, Col } from "@sketchpixy/rubix";

class ExamEmailOrNew extends Component {
  constructor(props) {
    super(props);
    console.log(props);
    this.state = {
      status: props.status ? props.status : "",
    };
  }

  render() {
    const { onClose } = this.props;
    const { status } = this.state;
    let message = "Please select from the given options";
    let warning = "";
    if (status) {
      message =
        "You already have completed this exam, do you want that in email or you want to start over the exam?";
      // warning = "Restarting the exam will erase their previous responses and generate a new DBQ";
    }

    return (
      <div
        className="overlay-msg"
        onClick={(e) => {
          onClose({ input: "" });
        }}
      >
        <div className="overlay-box">
          <h4 style={{ color: "#555" }}>{message}</h4>
          {/* <span style={{color: "#F12F39"}}>{warning}</span> */}
          <br />
          <br />
          <Row className="backnext-btn-div">
            {/* <Col xs={1}></Col> */}
            <Col sm={4} className="text-center">
              <Button
                lg
                type="button"
                bsStyle="primary"
                // style={{width : 'auto'}}
                className="back-btn ripple"
                onClick={(e) => {
                  onClose({ input: "cancel" });
                }}
              >
                Cancel
              </Button>
            </Col>
            <Col sm={4} className="text-center">
              <Button
                lg
                type="button"
                // style={{width : '125px'}}
                bsStyle="primary"
                className="next-btn ripple"
                onClick={(e) => {
                  onClose({ input: "email" });
                }}
              >
                Email Exam
              </Button>
            </Col>
            <Col sm={4} className="text-center">
              <Button
                lg
                type="button"
                // style={{width : 'auto'}}
                bsStyle="primary"
                className="next-btn ripple"
                onClick={(e) => {
                  onClose({ input: "new" });
                }}
              >
                Start over
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default ExamEmailOrNew;
